import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import api from "../../constants/api.js";
import Modal from "../../components/modal/modal.jsx";
import "./materia.css";

function Materia() {
  const { id_materia } = useParams();
  const navigate = useNavigate();

  const [titulo, setTitulo] = useState("");
  const [subtitulo, setSubtitulo] = useState("");
  const [texto, setTexto] = useState("");
  const [img, setImg] = useState("");
  const [open, setOpen] = useState(false);

  /* ================== BUSCAR MATÉRIA ================== */
  useEffect(() => {
    async function fetchMateria() {
      try {
        const response = await api.get(`/materias/${id_materia}`);

        if (response.data) {
          setTitulo(response.data.titulo);
          setSubtitulo(response.data.subtitulo || "");
          setTexto(response.data.texto);
          setImg(response.data.imagem_url);
        }
      } catch (error) {
        console.log(
          error.response?.data?.error ||
            "Erro ao buscar matéria"
        );
      }
    }

    fetchMateria();
  }, [id_materia]);

  /* ================== AÇÕES ================== */
  function editar() {
    setOpen(true);
  }

  function voltar() {
    navigate("/materias");
  }

  async function excluir() {
    try {
      await api.delete(`/materias/${id_materia}`);
      navigate("/materias");
    } catch (error) {
      console.log(
        error.response?.data?.error ||
          "Erro ao deletar matéria"
      );
    }
  }

  /* ================== ENVIAR EDIÇÃO ================== */
  async function enviarEdit() {
    // ✅ VALIDAÇÕES
    if (!titulo.trim()) {
      throw new Error("Título é obrigatório");
    }

    if (!texto.trim()) {
      throw new Error("Texto é obrigatório");
    }

    try {
      const formData = new FormData();
      formData.append("titulo", titulo);
      formData.append("subtitulo", subtitulo);
      formData.append("texto", texto);

      if (img && typeof img !== "string") {
        formData.append("imagem_url", img);
      }

      const response = await api.put(
        `/materias/${id_materia}`,
        formData
      );

      setImg(response.data.imagem_url || img);
      setOpen(false);
    } catch (error) {
      throw error; // 🔥 propaga para o Modal
    }
  }

  /* ================== RENDER ================== */
  return (
    <div className="container-post">
      <div className="post">
        {img && <img src={img} alt={titulo} />}

        <h1>{titulo}</h1>

        {subtitulo && (
          <h3 className="subtitulo">{subtitulo}</h3>
        )}

        <p>{texto}</p>

        <div className="botoes">
            <button onClick={editar}>Editar</button>

            <button
              onClick={() =>
                navigate(`/materias/admin/${id_materia}/midias`)
              }
            >
              Adicionar Mídias
            </button>

            <button onClick={excluir}>Excluir</button>

            <button onClick={voltar}>Voltar</button>
</div>

      </div>

      {/* MODAL */}
      <Modal
        isOpen={open}
        setOpen={setOpen}
        enviar={enviarEdit}
        tipo="materia"
        titulo={titulo}
        setTitulo={setTitulo}
        subtitulo={subtitulo}
        setSubtitulo={setSubtitulo}
        texto={texto}
        setTexto={setTexto}
        img={img}
        setImg={setImg}
        placeholderTitulo="Digite o título"
        placeholderSubtitulo="Digite o subtítulo"
        placeholderTexto="Digite o texto da matéria"
      />
    </div>
  );
}

export default Materia;
